export const validateEmail = (email) => {
    const emailRegex = /\S+@\S+\.\S+/; 
    return emailRegex.test(email);
  };